import React, {Component} from "react";
import lockIcon from "../../assets/24_lock_white.svg"
import whiteHelpIcon from "../../assets/24_help.svg"
import {Tag, TagType} from "components/common/Tag.component";

export class ApprovalStep4EyesHeader extends Component {

    render() {
        let {toggle, collapsed} = this.props;
        let toggleIconClass = "glyphicon font-18 margin-right glyphicon-menu-" + (collapsed ? "right" : "down");

        return (
            <div className="d-flex pr-0 justify-content-between align-items-center w-100">
                <span className="d-flex align-items-center">
                    <span className={toggleIconClass} onClick={toggle}/>
                    <span className="d-flex gap-8 align-items-center">
                        <span>
                            <strong className="step-header">{this.props.translate("workflowDetails.4EyesApproval.header")}</strong>
                        </span>
                        <img src={whiteHelpIcon}
                             alt="lock icon"
                             width="16"
                             title={this.props.translate("workflowDetails.4EyesApproval.headerInfo")}
                             className="white-icon-help"/>
                        {this.props.hasInvalidApprovers && <Tag type={TagType.WARNING} message={this.props.translate("workflows.invalidApprovers")} />}
                    </span>
                </span>
                <img src={lockIcon}
                     alt="lock icon"
                     width="16"/>
            </div>
        )

    }
}
